/* VAIRE shared UI: nav, cart drawer, search, popup, toasts, cards, motion. */
(function () {
  'use strict';
  const S = window.Store, P = window.VairePackshot;
  const $ = (sel, el) => (el || document).querySelector(sel);
  const $$ = (sel, el) => Array.from((el || document).querySelectorAll(sel));
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const WELCOME_CODE = 'VAIRE10';
  let setMenuState = () => {};

  /* ---------- templates ---------- */
  function navHTML(opts) {
    const L = window.VAIRE_LINKS || {};
    return `
    <nav class="nav ${opts.dark ? 'on-dark' : ''}" id="vnav">
      <a class="wordmark" href="/">VAIRE</a>
      <button class="menubtn" id="navMenu" aria-expanded="false" aria-controls="mobileMenu">MENU</button>
      <div class="links">
        <a href="/collections/all">SHOP</a>
        <a href="/collections/all?cat=skin">SKIN</a>
        <a href="/collections/all?cat=colour">COLOUR</a>
        <a href="/collections/all?cat=body">BODY</a>
        <a href="/collections/all?cat=tools">TOOLS</a>
        <a href="/pages/build-your-ritual">RITUAL</a>
        <a href="${L.about || '/pages/our-story'}">OUR STORY</a>
      </div>
      <div class="spacer"></div>
      <div class="tools">
        <span class="tc" id="navTc">00:00:00:00</span>
        <button class="iconbtn" id="navSearch" aria-label="Search">
          <svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="9" cy="9" r="6.2" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M13.8 13.8 L18 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
        </button>
        <a class="iconbtn" href="/collections/all?view=saved" id="navWish" aria-label="Saved items">
          <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 16.6 C5.2 13 3 10.2 3 7.6 A3.6 3.6 0 0 1 10 5.6 A3.6 3.6 0 0 1 17 7.6 C17 10.2 14.8 13 10 16.6 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>
          <span class="bub" id="wishN"></span>
        </a>
        <button class="iconbtn bag" id="navBag" aria-label="Open bag">
          <svg viewBox="0 0 20 20" aria-hidden="true"><rect x="3.6" y="6.4" width="12.8" height="11" rx="2" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M7 6.4 V5.2 a3 3 0 0 1 6 0 v1.2" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>
          <span class="bub red n" id="bagN"></span>
        </button>
      </div>
    </nav>
    <div class="mobile-menu" id="mobileMenu" aria-hidden="true">
      <div class="menu-inner">
        <div class="menu-kicker mono">THE VAIRE EDIT / NAVIGATION</div>
        <div class="menu-grid">
          <section class="menu-primary" aria-labelledby="menuShopLabel">
            <div class="menu-label mono" id="menuShopLabel">SHOP THE HOUSE</div>
            <a href="/collections/all"><span>Everything</span><small>${S.products.length} pieces</small></a>
            <a href="/collections/all?cat=skin"><span>Skin</span><small>Prep, treat, glow</small></a>
            <a href="/collections/all?cat=colour"><span>Colour</span><small>Lips, cheeks, eyes</small></a>
            <a href="/collections/all?cat=body"><span>Body</span><small>Polish and finish</small></a>
            <a href="/collections/all?cat=hair"><span>Hair</span><small>Care and styling</small></a>
            <a href="/collections/all?cat=tools"><span>Tools</span><small>Brushes and devices</small></a>
            <a href="/collections/all?cat=sets"><span>Sets</span><small>Ready-made edits</small></a>
          </section>
          <section class="menu-secondary" aria-labelledby="menuExploreLabel">
            <div class="menu-label mono" id="menuExploreLabel">EXPLORE</div>
            <a href="/pages/build-your-ritual">Build your ritual <span aria-hidden="true">&#8599;</span></a>
            <a href="/#film">Watch the film <span aria-hidden="true">&#8599;</span></a>
            <a href="${L.about || '/pages/our-story'}">Our story <span aria-hidden="true">&#8599;</span></a>
            <a href="/collections/all?view=saved">Saved pieces <span aria-hidden="true">&#8599;</span></a>
            <div class="menu-label mono care-label">CUSTOMER CARE</div>
            <a href="${L.faq || '/pages/faq'}">Frequently asked questions</a>
            <a href="${L.shipping || '/pages/shipping-returns'}">Shipping and returns</a>
            <a href="${L.contact || '/pages/contact'}">Contact Vaire</a>
          </section>
          <aside class="menu-offer">
            <div class="mono">THE HOUSE OFFER</div>
            <p>15 percent off two or more pieces. Free tracked U.S. shipping at $70. A 10-piece eye brush set at $120.</p>
            <a href="/collections/all" class="textlink">BEGIN THE EDIT</a>
          </aside>
        </div>
      </div>
    </div>`;
  }

  function drawerHTML() {
    return `
    <div class="scrim" id="scrim"></div>
    <aside class="drawer" id="drawer" aria-label="Shopping bag">
      <button class="close" id="drawerClose" aria-label="Close bag">&#10005;</button>
      <div class="head"><span class="t">Your Bag</span><span class="mono" id="bagStamp"></span></div>
      <div class="ship" id="shipWrap">
        <div class="copy" id="shipCopy"></div>
        <div class="track"><div class="fill" id="shipFill"></div></div>
      </div>
      <div class="items" id="bagItems"></div>
      <div class="upsell" id="bagUpsell"></div>
      <div class="foot" id="bagFoot"></div>
    </aside>`;
  }

  function searchHTML() {
    return `
    <div class="search" id="search">
      <button class="close mono" id="searchClose">CLOSE &#10005;</button>
      <div class="inner">
        <input id="searchInput" placeholder="Search the house" autocomplete="off" aria-label="Search products">
        <div class="hint" id="searchHint">Try serum, blush, gua sha, or a shade name</div>
        <div class="results" id="searchResults"></div>
      </div>
    </div>`;
  }

  function popupHTML() {
    return `
    <div class="popup" id="popup" role="dialog" aria-label="Guest list">
      <button class="x" id="popupClose" aria-label="Close">&#10005;</button>
      <div class="mono">THE GUEST LIST</div>
      <div class="t">10 percent off your first order.</div>
      <p>Early access to drops and the next scene of the film. No noise, one email a week.</p>
      <form id="popupForm"><input type="email" required placeholder="your@email.com" aria-label="Email"><button type="submit">JOIN</button></form>
      <div class="signup-success" id="popupSuccess" hidden>
        <span>Your first-order code</span>
        <button type="button" class="code" data-copy-code="${WELCOME_CODE}" aria-label="Copy ${WELCOME_CODE}">${WELCOME_CODE}<small>COPY</small></button>
        <p>Use it at checkout for 10 percent off. One use per customer.</p>
      </div>
    </div>`;
  }

  function footerHTML() {
    const L = window.VAIRE_LINKS || {};
    return `
    <footer class="credits">
      <div class="top">
        <div class="mono">THE GUEST LIST / BY ALESSA</div>
        <h4>She is still up.</h4>
        <p>Join for 10 percent off your first order and early access to the next scene.</p>
        <form id="footForm"><input type="email" required placeholder="your@email.com" aria-label="Email"><button type="submit">JOIN</button></form>
      </div>
      <div class="cols">
        <div class="col"><div class="h">SHOP</div>
          <a href="/collections/all">Everything</a><a href="/collections/all?cat=skin">Skin</a>
          <a href="/collections/all?cat=colour">Colour</a><a href="/collections/all?cat=body">Body</a>
          <a href="/collections/all?cat=hair">Hair</a><a href="/collections/all?cat=tools">Tools</a>
          <a href="/collections/all?cat=sets">Sets</a></div>
        <div class="col"><div class="h">THE HOUSE</div>
          <a href="/#film">The film</a><a href="/collections/all?view=saved">Saved</a>
          <a href="/collections/all?sort=new">New arrivals</a><a href="/collections/all?edit=arrival">The Arrival edit</a></div>
        <div class="col"><div class="h">CARE</div>
          <a href="${L.about || '/pages/our-story'}">About Vaire</a>
          <a href="${L.faq || '/pages/faq'}">FAQ</a>
          <a href="${L.shipping || '/pages/shipping-returns'}">Shipping</a>
          <a href="${L.refund || '/pages/refund-policy'}">Returns</a>
          <a href="${L.contact || '/pages/contact'}">Contact</a></div>
      </div>
      <div class="fine"><span>&copy; 2026 VAIRE BEAUTY</span>
        <span><a href="${L.privacy || '/pages/data-sharing-opt-out'}" style="color:inherit;text-decoration:none">PRIVACY</a> &middot; <a href="${L.terms || '/pages/terms-of-service'}" style="color:inherit;text-decoration:none">TERMS</a></span>
        <span>A FILM IN FIFTEEN SECONDS</span></div>
    </footer>`;
  }

  /* ---------- product card ---------- */
  function cardHTML(p, opts) {
    opts = opts || {};
    const sale = !!p.compareAt;
    const shadeCount = p.shades && p.shades.length > 1 ? `<span class="s-count">${p.shades.length} shades</span>` : '';
    return `
    <a class="pcard" href="/products/${p.id}" data-pid="${p.id}">
      <span class="art" data-vtn="${p.id}">${P.art(p)}
        ${sale ? `<span class="badge">SAVE ${S.pct(p)}%</span>` : ''}
        <span class="frame">NO. ${String(p.no).padStart(3, '0')} / ${p.timecode}</span>
      </span>
      <button class="wish ${S.wish.has(p.id) ? 'on' : ''}" data-wish="${p.id}" aria-label="Save ${p.name}">${S.wish.has(p.id) ? '&#9829;' : '&#9825;'}</button>
      <button class="qadd" data-qadd="${p.id}" aria-label="Add ${p.name} to bag">+</button>
      <span class="meta"><span class="name">${p.name}</span>
        <span class="price">${sale ? `<s>${S.money(S.compareAt(p, 0))}</s>` : ''}<span class="now ${sale ? 'sale' : ''}">${S.money(S.price(p, 0))}</span></span></span>
      <span class="blurb">${p.blurb}${shadeCount ? ' &middot; ' + p.shades.length + ' shades' : ''}</span>
    </a>`;
  }

  /* ---------- toast ---------- */
  let toastT;
  function toast(msg) {
    let el = $('#toast');
    if (!el) { el = document.createElement('div'); el.id = 'toast'; el.className = 'toast'; document.body.appendChild(el); }
    el.textContent = msg; el.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(() => el.classList.remove('show'), 2600);
  }

  /* ---------- flashbulb + fly to bag ---------- */
  function flashbulb(btn) {
    if (!btn) return;
    if (!$('.flash', btn)) { const f = document.createElement('span'); f.className = 'flash'; btn.appendChild(f); }
    btn.classList.remove('flashing'); void btn.offsetWidth; btn.classList.add('flashing');
  }
  function flyToBag(fromEl, p) {
    const bag = $('#navBag');
    if (!bag || !fromEl) return;
    if (reduced) return; // large-travel motion is the one thing we swap under reduced motion
    const a = fromEl.getBoundingClientRect(), b = bag.getBoundingClientRect();
    const fl = document.createElement('div'); fl.className = 'flyer'; fl.innerHTML = P.art(p);
    fl.style.left = (a.left + a.width / 2 - 22) + 'px'; fl.style.top = (a.top + a.height / 2 - 28) + 'px';
    document.body.appendChild(fl);
    fl.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: `translate(${b.left + b.width / 2 - (a.left + a.width / 2)}px, ${b.top - (a.top + a.height / 2)}px) scale(.18)`, opacity: .4 }
    ], { duration: 620, easing: 'cubic-bezier(.2,.7,.2,1)' }).onfinish = () => fl.remove();
  }
  function springBadge() {
    const b = $('#navBag'); if (!b) return;
    b.classList.remove('spring'); void b.offsetWidth; b.classList.add('spring');
  }

  /* ---------- cart drawer ---------- */
  function fmtStamp(d) { return 'AT ' + d.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' }); }

  function renderBag() {
    const allItems = S.cart.items();
    const items = allItems.filter(i => !i.isGift);
    const giftLine = allItems.find(i => i.isGift);
    $('#bagN').textContent = S.cart.count() || ''; $('#bagN').hidden = !S.cart.count();
    $('#wishN').textContent = S.wish.count() || ''; $('#wishN').hidden = !S.wish.count();
    $('#bagStamp').textContent = fmtStamp(new Date());

    /* Confirmed promotion ladder: shipping at $70 and a 10-piece brush set at $120. */
    const GIFT_AT = 120;
    const GIFT_ID = '10pcs-eye-makeup-brushes-set-eyeshadow-blending-angled-brow-travel-bag-upgraded-eye-shadow-brush-set-professional-shading-defining-cruelty-free-vegan-for-beginner-makeup-artist-recommendation';
    const gift = S.byId(GIFT_ID), giftName = gift ? gift.name : 'VAIRE 10-Piece Essential Eye Brush Set';
    const sub = S.cart.merchandiseSubtotal ? S.cart.merchandiseSubtotal() : S.cart.subtotal();
    const merchandiseQty = items.reduce((total, item) => total + item.qty, 0);
    const editQualified = merchandiseQty >= 2;
    const editSavings = editQualified ? Math.round(sub * 15) / 100 : 0;
    const editTotal = Math.max(0, sub - editSavings);
    let copy;
    if (sub < S.FREE_SHIP) copy = `You are <b>${S.money(S.FREE_SHIP - sub)}</b> from free shipping`;
    else if (sub < GIFT_AT) copy = `<b>Free shipping is in.</b> ${S.money(GIFT_AT - sub)} more and the 10-Piece Eye Brush Set comes with it, on us`;
    else copy = giftLine
      ? `<b>Shipping is free and your gift is in.</b> The 10-Piece Eye Brush Set rides along`
      : `<b>You qualified for the gift.</b> Adding the 10-Piece Eye Brush Set now`;
    $('#shipCopy').innerHTML = copy;
    $('#shipFill').style.width = (Math.min(1, sub / GIFT_AT) * 100) + '%';

    const wrap = $('#bagItems');
    if (!items.length) {
      wrap.innerHTML = `<div class="empty"><div class="serif">Nothing in frame yet.</div>
        <p>The film has three products in it. Start there.</p>
        <a class="btn" href="/#film">PLAY THE FILM</a></div>`;
      $('#bagUpsell').innerHTML = ''; $('#bagFoot').innerHTML = ''; return;
    }
    wrap.innerHTML = items.map(i => {
      const p = S.byId(i.id);
      const shadeName = p.shades && i.shade != null && p.shades[i.shade] ? p.shades[i.shade].name : null;
      const line = typeof i.linePrice === 'number' ? i.linePrice : S.price(p, i.shade) * i.qty;
      return `<div class="line">
        <span class="thumb">${P.art(p, { shadeHex: shadeName ? p.shades[i.shade].hex : null })}</span>
        <span><span class="n">${p.name}</span>
          <span class="s">${shadeName ? shadeName + ' / ' : ''}NO. ${String(p.no).padStart(3, '0')}</span>
          <span class="qty"><button data-dq="${i.id}::${i.shade}" aria-label="Decrease">&minus;</button><span>${i.qty}</span><button data-iq="${i.id}::${i.shade}" aria-label="Increase">+</button></span></span>
        <span class="right"><span class="lt">${S.money(line)}</span><button class="rm" data-rm="${i.id}::${i.shade}">REMOVE</button></span>
      </div>`;
    }).join('') + (giftLine && gift ? `<div class="line" style="opacity:.92">
        <span class="thumb" style="background:#F0E2C8">${P.art(gift)}</span>
        <span><span class="n">${giftName}</span><span class="s">YOUR GIFT / $39.99 VALUE</span></span>
        <span class="right"><span class="lt" style="color:var(--champagne-deep)">FREE</span></span>
      </div>` : '');

    // upsell: 2 items sharing edit or category with the bag, not already in it
    const inBag = new Set(items.map(i => i.id));
    const last = S.byId(items[items.length - 1].id);
    const pool = S.products.filter(p => !inBag.has(p.id))
      .sort((a, b) => (score(b) - score(a)));
    function score(p) {
      let s = 0;
      if (last.edit && p.edit === last.edit) s += 3;
      if (p.category === last.category) s += 2;
      if ((p.tags || []).includes('bestseller')) s += 2;
      return s;
    }
    const ups = pool.slice(0, 2);
    $('#bagUpsell').innerHTML = ups.length ? `<div class="l">COMPLETE THE LOOK</div>
      <div class="row">${ups.map(p => `<div class="upcard"><span class="th">${P.art(p)}</span>
        <span><span class="un">${p.name}</span><br><span class="up">${S.money(S.price(p, 0))}</span></span>
        <button data-qadd="${p.id}" aria-label="Add ${p.name}">+</button></div>`).join('')}</div>` : '';

    $('#bagFoot').innerHTML = `
      <div class="row"><span>MERCHANDISE SUBTOTAL</span><span>${S.money(sub)}</span></div>
      ${editQualified ? `
        <div class="row saving"><span><b>15% EDIT SAVINGS</b><small>AUTOMATIC &middot; 2+ PIECES</small></span><span>-${S.money(editSavings)}</span></div>
        <div class="row estimated"><span>ESTIMATED TOTAL</span><span>${S.money(editTotal)}</span></div>
      ` : `
        <div class="edit-unlock"><b>15% OFF AT 2+ PIECES</b><span>Add ${2 - merchandiseQty} more ${2 - merchandiseQty === 1 ? 'piece' : 'pieces'} to unlock it automatically.</span></div>
      `}
      <div class="note">Your automatic savings are confirmed at checkout. Typically arrives around ${S.deliveryDate()}. 30 day returns.</div>
      <button class="btn wide" id="checkoutBtn">CHECKOUT<span class="flash"></span></button>
      <div class="note" style="text-align:center;margin:10px 0 0">SECURE SHOPIFY CHECKOUT &middot; SHIPPING SHOWN BEFORE PAYMENT</div>`;
  }

  let bagOpen = false;
  function openBag() { bagOpen = true; renderBag(); $('#drawer').classList.add('open'); $('#scrim').classList.add('open'); }
  function closeBag() { bagOpen = false; $('#drawer').classList.remove('open'); $('#scrim').classList.remove('open'); }

  /* ---------- add to cart (public) ---------- */
  function addToCart(id, shade, sourceEl, btnEl) {
    const p = S.byId(id); if (!p) return;
    if (p.shades && shade != null && p.shades[shade] && p.shades[shade].available === false) {
      toast('That option is currently unavailable.'); return;
    }
    if (btnEl) btnEl.disabled = true;
    Promise.resolve(S.cart.add(id, shade)).then(() => {
      flashbulb(btnEl); flyToBag(sourceEl, p); springBadge();
      setTimeout(() => { renderBag(); if (!bagOpen) openBag(); }, reduced ? 60 : 660);
      document.dispatchEvent(new CustomEvent('vaire:added'));
    }).catch(error => {
      console.error('VAIRE cart:', error && error.message ? error.message : error);
      toast('We could not add that piece. Please try again.');
    }).finally(() => { if (btnEl) btnEl.disabled = false; });
  }

  /* ---------- search ---------- */
  function initSearch() {
    const input = $('#searchInput'), results = $('#searchResults');
    function run(q) {
      q = q.trim().toLowerCase();
      if (!q) { results.innerHTML = ''; $('#searchHint').textContent = 'Try serum, blush, gua sha, or a shade name'; return; }
      const hits = S.products.filter(p => {
        const hay = [p.name, p.category, p.subcategory, p.blurb, (p.tags || []).join(' '),
        (p.shades || []).map(s => s.name).join(' ')].join(' ').toLowerCase();
        return q.split(/\s+/).every(w => hay.includes(w));
      }).slice(0, 12);
      $('#searchHint').textContent = hits.length ? hits.length + ' results' : 'Nothing found. Try skin, colour, body, hair, tools, or sets.';
      results.innerHTML = hits.map(p => cardHTML(p)).join('');
    }
    input.addEventListener('input', () => run(input.value));
    document.addEventListener('keydown', e => {
      if (e.key === '/' && !/input|textarea/i.test(document.activeElement.tagName)) { e.preventDefault(); openSearch(); }
      if (e.key === 'Escape') { closeSearch(); closeBag(); hidePopup(); setMenuState(false); }
    });
  }
  function openSearch() { $('#search').classList.add('open'); setTimeout(() => $('#searchInput').focus(), 60); }
  function closeSearch() { $('#search').classList.remove('open'); }

  /* ---------- popup ---------- */
  let popupShown = false;
  function canPopup() { return !popupShown && !sessionStorage.getItem('vaire_popup') && !localStorage.getItem('vaire_guest'); }
  function showPopup() {
    if (!canPopup()) return;
    popupShown = true; sessionStorage.setItem('vaire_popup', '1');
    $('#popup').classList.add('open');
  }
  function hidePopup() { $('#popup') && $('#popup').classList.remove('open'); }
  function initPopup(mode) {
    if (!canPopup()) return;
    if (mode === 'scroll') {
      let armed = true;
      addEventListener('scroll', () => {
        if (!armed) return;
        const depth = (scrollY + innerHeight) / document.documentElement.scrollHeight;
        if (depth > .55) { armed = false; setTimeout(showPopup, 600); }
      }, { passive: true });
    } else if (mode === 'pdp') {
      document.addEventListener('mouseleave', e => { if (e.clientY < 8) showPopup(); });
      document.addEventListener('vaire:added', () => setTimeout(() => { if (!bagOpen) showPopup(); }, 1200), { once: true });
    }
  }

  /* ---------- reveal observer ---------- */
  function initReveals() {
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('inview'); io.unobserve(e.target); }
    }), { threshold: .18 });
    $$('[data-reveal]').forEach(el => io.observe(el));
  }

  /* ---------- house motion ---------- */
  function initHouseMotion() {
    if (reduced || !('IntersectionObserver' in window)) {
      document.body.classList.add('motion-reduced');
      return;
    }
    document.body.classList.add('motion-enabled');
    const revealSelector = [
      '.pcard', '.native-card', '.stat', '.service-strip > div', '.ritual-steps > div',
      '.page-hero > *', '.page-grid > *', '.contact-layout > *', '.faq-layout > *',
      '.story-intro > *', '.story-body > *', '.story-gallery > *', '.page-cta > *',
      '.quick-facts > *', '.acc', '.rstep', '.credits .col', '.credits .top > *'
    ].join(',');
    const mediaSelector = '.band > img, .story-portrait img, .story-gallery figure img, .native-card .media img';
    const revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('motion-in');
      revealObserver.unobserve(entry.target);
    }), { threshold: .08, rootMargin: '0px 0px -5% 0px' });

    function prepare(root) {
      if (!root || root.nodeType !== 1) return;
      const nodes = [];
      if (root.matches && root.matches(revealSelector)) nodes.push(root);
      if (root.querySelectorAll) nodes.push(...root.querySelectorAll(revealSelector));
      nodes.forEach(el => {
        if (el.classList.contains('motion-item')) return;
        el.classList.add('motion-item');
        const siblings = el.parentElement ? Array.from(el.parentElement.children).filter(x => x.matches && x.matches(revealSelector)) : [];
        const localIndex = Math.max(0, siblings.indexOf(el));
        el.style.setProperty('--motion-delay', Math.min(localIndex * 55, 220) + 'ms');
        if (el.getBoundingClientRect().top < innerHeight * .92) requestAnimationFrame(() => el.classList.add('motion-in'));
        else revealObserver.observe(el);
      });
      const media = [];
      if (root.matches && root.matches(mediaSelector)) media.push(root);
      if (root.querySelectorAll) media.push(...root.querySelectorAll(mediaSelector));
      media.forEach(el => {
        if (el.classList.contains('motion-media')) return;
        el.classList.add('motion-media');
        if (el.getBoundingClientRect().top < innerHeight) requestAnimationFrame(() => el.classList.add('motion-in'));
        else revealObserver.observe(el);
      });
    }
    prepare(document.body);
    const motionRoot = document.querySelector('main') || document.body;
    new MutationObserver(entries => entries.forEach(entry => entry.addedNodes.forEach(prepare)))
      .observe(motionRoot, { childList: true, subtree: true });
  }

  async function submitNewsletter(form) {
    const email = $('input[type=email]', form).value;
    const proxy = $('#VaireNewsletterProxy'), proxyEmail = $('#VaireNewsletterEmail');
    if (!proxy || !proxyEmail) {
      localStorage.setItem('vaire_guest', '1');
      return true;
    }
    const button = $('button[type=submit]', form); button.disabled = true;
    proxyEmail.value = email;
    try {
      const response = await fetch(proxy.action, { method: 'POST', body: new FormData(proxy), credentials: 'same-origin' });
      if (!response.ok) throw new Error('Signup failed');
      localStorage.setItem('vaire_guest', '1');
      return true;
    } catch (err) {
      toast('We could not add you just now. Please try again.');
      return false;
    } finally { button.disabled = false; }
  }

  function revealWelcomeCode(form) {
    if (form.id === 'popupForm') {
      form.hidden = true;
      $('#popupSuccess').hidden = false;
      $('.t', $('#popup')).textContent = 'Welcome to the guest list.';
      $('p', $('#popup')).hidden = true;
      return;
    }
    form.innerHTML = `<span class="foot-code">${WELCOME_CODE}</span><button type="button" data-copy-code="${WELCOME_CODE}">COPY CODE</button>`;
  }

  async function copyCode(code) {
    try { await navigator.clipboard.writeText(code); }
    catch (err) {
      const field = document.createElement('textarea'); field.value = code; document.body.appendChild(field);
      field.select(); document.execCommand('copy'); field.remove();
    }
    toast(`${code} copied. Use it at checkout.`);
  }

  /* ---------- wiring ---------- */
  function init(opts) {
    opts = opts || {};
    document.body.insertAdjacentHTML('afterbegin', navHTML(opts));
    document.body.insertAdjacentHTML('beforeend', drawerHTML() + searchHTML() + popupHTML());
    if (opts.footer !== false) document.body.insertAdjacentHTML('beforeend', footerHTML());

    const nav = $('#vnav');
    function navState() {
      /* deferred one frame so scroll-position measurements land first */
      requestAnimationFrame(() => {
        const held = typeof window.VAIRE_NAV_HOLD === 'function' && !window.VAIRE_NAV_HOLD();
        nav.classList.toggle('solid', !held && (scrollY > 24 || !!opts.solidNav));
      });
    }
    addEventListener('scroll', navState, { passive: true }); navState();

    $('#navBag').addEventListener('click', openBag);
    const menu = $('#mobileMenu');
    function setMenu(open) {
      menu.classList.toggle('open', open);
      menu.setAttribute('aria-hidden', String(!open));
      $('#navMenu').setAttribute('aria-expanded', String(open));
      $('#navMenu').textContent = open ? 'CLOSE' : 'MENU';
      nav.classList.toggle('menu-open', open);
      document.body.classList.toggle('menu-is-open', open);
    }
    setMenuState = setMenu;
    $('#navMenu').addEventListener('click', () => setMenu(!menu.classList.contains('open')));
    menu.addEventListener('click', e => { if (e.target.closest('a')) setMenu(false); });
    $('#drawerClose').addEventListener('click', closeBag);
    $('#scrim').addEventListener('click', () => { closeBag(); });
    $('#navSearch').addEventListener('click', openSearch);
    $('#searchClose').addEventListener('click', closeSearch);
    $('#popupClose').addEventListener('click', hidePopup);
    $('#popupForm').addEventListener('submit', async e => {
      e.preventDefault();
      if (await submitNewsletter(e.currentTarget)) revealWelcomeCode(e.currentTarget);
    });

    document.addEventListener('click', e => {
      const t = e.target;
      const copy = t.closest('[data-copy-code]');
      if (copy) { copyCode(copy.dataset.copyCode); return; }
      const qadd = t.closest('[data-qadd]');
      if (qadd) { e.preventDefault(); e.stopPropagation(); addToCart(qadd.dataset.qadd, defShade(qadd.dataset.qadd), qadd, qadd.closest('.btn') ? qadd : null); return; }
      const wishBtn = t.closest('[data-wish]');
      if (wishBtn) {
        e.preventDefault(); e.stopPropagation();
        const on = S.wish.toggle(wishBtn.dataset.wish);
        wishBtn.classList.toggle('on', on); wishBtn.textContent = on ? '\u2665' : '\u2661';
        $('#wishN').textContent = S.wish.count() || ''; $('#wishN').hidden = !S.wish.count();
        toast(on ? 'Saved. It will wait for you.' : 'Removed from saved.');
        return;
      }
      const dq = t.closest('[data-dq]'); if (dq) { const [id, sh] = dq.dataset.dq.split('::'); S.cart.setQty(id, sh === 'null' ? null : +sh, qtyOf(id, sh) - 1); renderBag(); return; }
      const iq = t.closest('[data-iq]'); if (iq) { const [id, sh] = iq.dataset.iq.split('::'); S.cart.setQty(id, sh === 'null' ? null : +sh, qtyOf(id, sh) + 1); renderBag(); return; }
      const rm = t.closest('[data-rm]'); if (rm) { const [id, sh] = rm.dataset.rm.split('::'); S.cart.remove(id, sh === 'null' ? null : +sh); renderBag(); return; }
      if (t.closest('#checkoutBtn')) { flashbulb(t.closest('#checkoutBtn')); location.href = '/checkout'; return; }
      const dt = t.closest('[data-toast]'); if (dt) { e.preventDefault(); toast(dt.dataset.toast); return; }
      const card = t.closest('.pcard');
      if (card && 'startViewTransition' in document) {
        const art = $('.art', card); if (art) art.style.viewTransitionName = 'product-hero';
      }
    });

    function qtyOf(id, sh) {
      const shade = sh === 'null' ? null : +sh;
      const it = S.cart.items().find(i => !i.isGift && i.id === id && i.shade === shade);
      return it ? it.qty : 0;
    }
    function defShade(id) { const p = S.byId(id); return p.shades && p.shades.length ? 0 : null; }

    const footForm = $('#footForm');
    if (footForm) footForm.addEventListener('submit', async e => {
      e.preventDefault();
      if (await submitNewsletter(e.currentTarget)) revealWelcomeCode(e.currentTarget);
    });

    S.on('cart', () => { $('#bagN').textContent = S.cart.count() || ''; $('#bagN').hidden = !S.cart.count(); });
    renderBag();
    initSearch();
    if (opts.popup) initPopup(opts.popup);
    initReveals();
    initHouseMotion();
  }

  window.VaireUI = {
    init, cardHTML, toast, addToCart, openBag, flashbulb, springBadge, showPopup,
    setTimecode(s) { const el = $('#navTc'); if (el) el.textContent = s; },
    reduced,
  };
})();

